module.exports = __webpack_public_path__ + "media/CorrectAnswer.b7919538.mp3";